import { Box, CircularProgress } from "@mui/material"
import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import type { FC } from "react"

import { TransferFormPage } from "@/screens/Inventory/subfeatures/Transfers/components"
import { useGetTransferWarehouse } from "@/screens/Inventory/subfeatures/Transfers/hooks/useGetTransferWarehouse"
import { transferLaunchFormSchema } from "@/screens/Inventory/subfeatures/Transfers/schemas"

const TransferCreatePage: FC = () => {
  const { type, sourceWarehouseAreaId } = Route.useSearch()
  const { warehouseArea, isFetching } = useGetTransferWarehouse(sourceWarehouseAreaId)

  if (!warehouseArea) {
    return <Box className='flex h-full items-center justify-center'>{isFetching && <CircularProgress size={48} />}</Box>
  }

  return <TransferFormPage type={type} sourceWarehouseArea={warehouseArea} />
}

export const Route = createFileRoute("/app/inventory/transfers/new")({
  validateSearch: zodValidator(transferLaunchFormSchema),
  component: TransferCreatePage,
})
